import { useQuery } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { ApiKey } from '../components/enums'

export type ClaimRequestParam = {
  threatId: number
}

export const getClaimRequest = async (params: ClaimRequestParam) => {
  return axios.get(endpoints.getClaimRequest, { params })
}

export const useClaimRequest = (params: ClaimRequestParam) => {
  return useQuery([ApiKey.incidents, ApiKey.list, params], () => getClaimRequest(params))
}
